export const CITIZEN_GREETING_SPEED = 2.2;

export class CitizenGreeting {
  private selected = false;
  private started = -Infinity;

  constructor(private readonly seconds: number) {}

  select(value: boolean, now: number): void {
    if (value === this.selected) return;
    this.selected = value;
    if (value && now - this.started >= (this.seconds / CITIZEN_GREETING_SPEED) * 1000)
      this.started = now;
  }

  phase(now: number): number | null {
    if (this.selected && now - this.started >= 11000) this.started = now;
    const elapsed = ((now - this.started) / 1000) * CITIZEN_GREETING_SPEED;
    return elapsed < this.seconds ? elapsed : null;
  }
}
